import { css } from '@emotion/css'
import { spacing, fontFamily, fontSize, fontWeight, lineHeight, borderRadius } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'
import { accessiblyHidden } from '../../utils/styleUtils'

const styles = {
  wrapper: css({
    display: 'flex',
    alignItems: 'flex-start',
    position: 'relative',
    padding: spacing.default,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.default,
    border: '1px solid transparent',
    borderRadius: borderRadius.default,
    whiteSpace: 'pre-wrap',
  }),

  wrapperDismissible: css({
    paddingRight: 40,
  }),

  icon: css({
    marginRight: spacing.small,
  }),

  dismiss: css({
    // override default button styles
    border: 'none',
    margin: 0,
    textDecoration: 'none',
    background: 'none',

    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    padding: shorthandHelper([0, spacing.default]),
  }),

  accessiblyHidden: css(accessiblyHidden),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)

  // Light theme is special
  if (theme === 'light') {
    return css({
      backgroundColor: colors.athensGray,
      color: colors.jumbo,
      borderColor: hexToRgba(themed.base, 0.3),
    })
  }

  return css({
    backgroundColor: themed.light,
    color: themed.base,
    borderColor: hexToRgba(themed.base, 0.3),
  })
}

export const iconColor = theme => {
  if (theme === 'light') return colors.jumbo

  const themed = getThemeColors(theme)
  return themed.base
}
